import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { BookingModal } from "~/components/admin/bookings";
import { ClientModal } from "~/components/admin/client-management";
import { InventoryModal } from "~/components/admin/inventories";
import PageMeta from "~/components/common/meta";
import { SidebarProvider, useSidebar } from "~/providers/sidebar.provider";
import { useAuth } from "~/store";
import { Header } from "./header";
import Sidebar from "./sidebar";

const Layout = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  return (
    <div className="flex min-h-dvh bg-gray-100">
      <Sidebar />
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <Header />
        <div className="px-3 py-2 md:px-4 md:py-3 bg-gray-50 min-h-[calc(100vh-4rem)]">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export const AdminLayout: FC = () => {
  const { isAuth } = useAuth();

  if (!isAuth) {
    return <Navigate to="/login" />;
  }
  return (
    <SidebarProvider>
      <PageMeta
        title="Admin Dashboard | Art Handler"
        description="Admin Dashboard"
      />
      <Layout />
      <BookingModal />
      <ClientModal />
      <InventoryModal />
    </SidebarProvider>
  );
};

export default AdminLayout;
